import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { getNumericInputAttrs } from '../../../utils';

export default function InputNumeric({
  questionRefId,
  min,
  max,
  decimals = 0,
}) {
  const inputRef = useRef(null);
  const { inputMode, pattern, step } = getNumericInputAttrs(decimals);

  const onKeyDown = useCallback((event) => {
    if (event.keyCode === 13 && inputRef.current) {
      inputRef.current.blur();
    }
  }, []);

  const onBlur = useCallback(() => {
    Pollfish.ui.validateQuestionAnswers(
      Pollfish.ui.getClosestQuestionWrapperElement(inputRef?.current),
    );
  }, []);

  const elementId = `freeTextNumerical-${questionRefId}`;
  if (Pollfish.helper.json.sdk_version < 17 && Pollfish.helper.isAndroid()) {
    return (
      <textarea
        rows="1"
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={Pollfish.helper.shouldAutofocus()}
        id={elementId}
        className="input-text input-text--numeric"
        onBlur={onBlur}
        aria-label="numeric value"
      ></textarea>
    );
  }
  return (
    <div className="form-container text-center">
      <input
        ref={inputRef}
        id={elementId}
        className="input-text input-text--numeric"
        type="number"
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        min={min}
        max={max}
        inputMode={inputMode}
        pattern={pattern}
        step={step}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        aria-label="numeric value"
      />
    </div>
  );
}

InputNumeric.propTypes = {
  questionRefId: PropTypes.string.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  decimals: PropTypes.number,
};
